import { InvestmentType } from '../generated/graphql';

export const INVESTMENT_VALUE_DECAY_LIMIT_IN_MONTHS = 3;

export const BENEFICIARY_INFORMATION_INVESTMENT_TYPES: InvestmentType[] = [
  InvestmentType.IndividualRetirementAccount,
  InvestmentType.RothIndividualRetirementAccount,
  InvestmentType.Subsection_401KAccount,
  InvestmentType.RothSubsection_401KAccount,
  InvestmentType.SimpleIndividualRetirementAccount,
  InvestmentType.SimplifiedEmployeePensionAccount,
  InvestmentType.QualifiedTuitionPlan_529,
  InvestmentType.ProfitSharingAccount,
  InvestmentType.DefinedBenefitPlanAccount,
  InvestmentType.HealthSavingsAccount,
  InvestmentType.MinorIndividualRetirementAccount,
  InvestmentType.MinorRothIndividualRetirementAccount,
  InvestmentType.TaxShelteredAnnuity_403BAccount,
  InvestmentType.DeferredCompensationPlan_457BAccount,
  InvestmentType.Annuity,
  InvestmentType.TraditionalSimpleIraAccount,
  InvestmentType.RothSimpleIraAccount,
  InvestmentType.TraditionalSepIraAccount,
  InvestmentType.RothSepIraAccount,
  InvestmentType.Traditional_403BAccount,
  InvestmentType.Roth_403BAccount,
  InvestmentType.Traditional_457BAccount,
  InvestmentType.Roth_457BAccount,
];

export const TAX_FREE_QUALIFIED_INVESTMENT_TYPES: InvestmentType[] = [
  InvestmentType.RothIndividualRetirementAccount,
  InvestmentType.RothSubsection_401KAccount,
] as const;

export const TAX_DEFERRED_QUALIFIED_INVESTMENT_TYPES: InvestmentType[] = [
  InvestmentType.IndividualRetirementAccount,
  InvestmentType.Subsection_401KAccount,
  InvestmentType.SimpleIndividualRetirementAccount,
  InvestmentType.SimplifiedEmployeePensionAccount,
  InvestmentType.ProfitSharingAccount,
  InvestmentType.TaxShelteredAnnuity_403BAccount,
  InvestmentType.DeferredCompensationPlan_457BAccount,
] as const;

export const OTHER_QUALIFIED_INVESTMENT_TYPES: InvestmentType[] = [
  InvestmentType.Annuity,
  InvestmentType.QualifiedTuitionPlan_529,
  InvestmentType.HealthSavingsAccount,
  InvestmentType.MinorIndividualRetirementAccount,
  InvestmentType.MinorRothIndividualRetirementAccount,
] as const;

export const AFTER_TAX_SAVINGS_INVESTMENT_TYPES: InvestmentType[] = [
  InvestmentType.PrivateStock,
  InvestmentType.Cryptocurrency,
  InvestmentType.UniversalTrustForMinorAccount,
  InvestmentType.BrokerageAccount,
  InvestmentType.StockOption,
  InvestmentType.RothSubsection_401KAccount,
  InvestmentType.RothIndividualRetirementAccount,
] as const;

export const EDUCATION_SAVINGS_INVESTMENT_TYPES: InvestmentType[] = [InvestmentType.QualifiedTuitionPlan_529] as const;

export const PRE_TAX_SAVINGS_INVESTMENT_TYPES: InvestmentType[] = [
  InvestmentType.Subsection_401KAccount,
  InvestmentType.Annuity,
  InvestmentType.DefinedBenefitPlanAccount,
  InvestmentType.HealthSavingsAccount,
  InvestmentType.IndividualRetirementAccount,
  InvestmentType.MinorIndividualRetirementAccount,
  InvestmentType.MinorRothIndividualRetirementAccount,
  InvestmentType.ProfitSharingAccount,
  InvestmentType.SimpleIndividualRetirementAccount,
  InvestmentType.SimplifiedEmployeePensionAccount,
  InvestmentType.TaxShelteredAnnuity_403BAccount,
  InvestmentType.DeferredCompensationPlan_457BAccount,
] as const;

export const INVESTMENT_TYPES: InvestmentType[] = [
  InvestmentType.BrokerageAccount,
  InvestmentType.IndividualRetirementAccount,
  InvestmentType.RothIndividualRetirementAccount,
  InvestmentType.Subsection_401KAccount,
  InvestmentType.RothSubsection_401KAccount,
  InvestmentType.SimpleIndividualRetirementAccount,
  InvestmentType.SimplifiedEmployeePensionAccount,
  InvestmentType.QualifiedTuitionPlan_529,
  InvestmentType.ProfitSharingAccount,
  InvestmentType.DefinedBenefitPlanAccount,
  InvestmentType.HealthSavingsAccount,
  InvestmentType.MinorIndividualRetirementAccount,
  InvestmentType.MinorRothIndividualRetirementAccount,
  InvestmentType.UniversalTrustForMinorAccount,
  InvestmentType.Cryptocurrency,
  InvestmentType.StockOption,
  InvestmentType.PrivateStock,
  InvestmentType.TaxShelteredAnnuity_403BAccount,
  InvestmentType.Annuity,
] as const;
